import { ref } from 'vue';
import { FEEDBACK_TYPES } from "./feedback.constants"
export default {
    name: "FeedbackToolbar",
    props: {
        itemId: {
            type: Number,
            required: true
        },
        labels: {
            type: Object,
        },
    },
    setup(props, { emit }) {
        const feedback = ref(null);

        const handleFeedback = (type) => {
            const previousFeedback = feedback.value;
            feedback.value = feedback.value === type ? null : type;


            emit("onFeedback", {
                feedback: previousFeedback && feedback.value === null
                    ? `remove-${previousFeedback}`
                    : feedback.value,
                id: props.itemId
            });
        };

        return {
            FEEDBACK_TYPES,
            feedback,
            handleFeedback
        };
    }
}